import { FC, ReactElement, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';

interface LoadTemplateDialogArgs {
  list: any[];
  open: boolean;
  createTemplatePath: string;
  onLoad: (template: any) => void;
  onClose: (e: any, reason: any) => void;
}

const LoadTemplateDialog: FC<LoadTemplateDialogArgs> = ({
  list,
  open,
  createTemplatePath,
  onLoad,
  onClose
}): ReactElement => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  // Filter templates based on search term
  const filteredList = list.filter((template) =>
    template.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const templates = filteredList.map((template, index) => {
    return (
      <div
        key={index}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '15px',
          alignItems: 'center'
        }}
      >
        <span style={{ fontSize: '12px' }}>{template.name}</span>
        <Button variant="outlined" type="button" onClick={() => onLoad(template)}>
          Load Template
        </Button>
      </div>
    );
  });

  return (
    <Dialog open={open} onClose={onClose} sx={dialogStyle}>
      <DialogTitle
        style={{ display: 'flex', flexDirection: 'column', color: '#1F3268', marginTop: '20px', fontSize: '18px', paddingBottom: '10px' }}
      >
        <span style={{ marginBottom: '15px' }}>Load from template</span>
        <TextField
          fullWidth
          size="small"
          placeholder="Search templates by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          autoComplete='off'
          sx={{
            '& .MuiOutlinedInput-root': {
              fontSize: '14px',
              backgroundColor: '#f5f5f5'
            }
          }}
        />
      </DialogTitle>
      <DialogContent style={{ padding: '0 0 27px' }}>
        <div style={{ margin: '0 25px 0 25px', color: '#000' }}>
          {templates.length > 0 ? (
            templates
          ) : (
            <div style={{ textAlign: 'center', padding: '20px', color: '#999', fontSize: '14px' }}>
              No templates found
            </div>
          )}
        </div>
      </DialogContent>
      <div style={dividerStyle} />
      <DialogActions style={{ marginRight: '28px', padding: '0 0 35px 0' }}>
        <Button
          variant="contained"
          type="button"
          autoFocus
          onClick={() => navigate(createTemplatePath)}
        >
          Create a new template
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoadTemplateDialog;

const dialogStyle = {
  '.MuiPaper-root': {
    background: '#fff',
    borderRadius: '8px',
    width: '480px',
    minHeight: '279px'
  }
};

const dividerStyle = {
  width: '90%',
  marginLeft: 'auto',
  marginRight: 'auto',
  height: '1px',
  backgroundColor: '#eee',
  marginBottom: '27px'
};
